import CheckBoxLabelHookForm from "components/CheckBoxLabelHookForm";
import TextInputLabelHookForm from "components/TextInputLabelHookForm";
import React, { useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useRecoilValue } from "recoil";
import { IOfficeStatusDetails } from "../types";
import { editStateOfficeStatusDetails } from "../atoms/atoms";
import SelectHookFormSingle from "components/SelectHookFormSingle";
import useOfficeStatus from "../../OfficeStatus/hooks/useOfficeStatus";

export const OfficeStatusDetailsDetails = (props: {
  setChanges: React.Dispatch<React.SetStateAction<boolean>>;
  data: IOfficeStatusDetails | undefined;
}) => {
  // Props drilled
  const { data, setChanges } = props;

  // Recoil Hook
  const edit = useRecoilValue(editStateOfficeStatusDetails);

  // Form Functions
  const { register } = useFormContext();
  const formMethods = useFormContext();

  // Local Hooks

  const [inputData, setInputData] = useState(
    data?.officeStatusDetailsName || ""
  );
  const [checkBoxChanges, setCheckBoxChanges] = useState(data?.isActive);
  const [dropBoxChanges, setDropBoxChanges] = useState(
    data?.officeStatusId || ""
  );

  const { data: officeStatus, isFetching: officeStatusLoading } =
    useOfficeStatus();

  const officeStatusOptions = officeStatus?.data.map((x) => {
    return {
      label: x.status,
      value: x.officeStatusId,
    };
  });

  const dropDownOpt = officeStatusOptions && [...officeStatusOptions];

  return (
    <>
      <div className="bg-bgDB">
        <div className="m-2 bg-white box-shadow h-full">
          <div className="grid grid-cols-6 mx-2 p-2 place-items-center">
            <div className="px-1 my-2 col-span-3 w-full">
              <TextInputLabelHookForm
                name="officeStatusDetailsName"
                label="Office Status Details Name"
                type="text"
                onChange={(e) => {
                  setInputData(e.target.value);

                  if (
                    e.target.value.trim() === "" ||
                    inputData.trim() === "" ||
                    (e.target.value === data?.officeStatusDetailsName &&
                      dropBoxChanges == data?.officeStatusId &&
                      checkBoxChanges == data?.isActive)
                  ) {
                    setChanges(false);
                  } else {
                    setChanges(true);
                  }
                  e.target.value = e.target.value.replace(/\s+/g, " ");
                }}
                required={true}
                className={
                  formMethods.formState.errors.modelName &&
                  formMethods.formState.errors.modelName.message &&
                  "border-2 border-red-500 col-span-2 "
                }
                register={formMethods.register("officeStatusDetailsName", {
                  required: {
                    value: true,
                    message: "Required Field",
                  },
                })}
                maxLength={255}
              />
            </div>

            <div className="px-2 my-2 col-span-2 w-full">
              <Controller
                name="officeStatusId"
                control={formMethods.control}
                rules={{ required: true }}
                render={({ field }) => (
                  <SelectHookFormSingle
                    placeHolder={data?.status}
                    isClearable={false}
                    field={field}
                    onChange={(e) => {
                      field.onChange(e ? e.value : null);
                      setDropBoxChanges(e.value);

                      if (
                        e.value === 0 ||
                        inputData.trim() === "" ||
                        (e.value === data?.officeStatusId &&
                          inputData == data?.officeStatusDetailsName &&
                          checkBoxChanges == data?.isActive)
                      ) {
                        setChanges(false);
                      } else {
                        setChanges(true);
                      }
                    }}
                    value={field.value}
                    isLoading={officeStatusLoading}
                    options={dropDownOpt}
                    label="Office Status"
                    className={
                      formMethods.formState.errors.state &&
                      "border-2 border-red-500 col-span-2 "
                    }
                    required={true}
                  />
                )}
              />
            </div>

            {edit && (
              <div className="px-3 my-2 w-full">
                <CheckBoxLabelHookForm
                  name="isActive"
                  label={
                    checkBoxChanges
                      ? "Uncheck to Deactivate"
                      : "Check to Activate"
                  }
                  type="checkbox"
                  validation={{
                    required: {
                      value: false,
                      message: "Required Field",
                    },
                  }}
                  onClick={(e) => {
                    setCheckBoxChanges(e.target.checked);

                    if (
                      inputData?.trim() === "" ||
                      (e.target.checked === data?.isActive &&
                        dropBoxChanges == data?.officeStatusId &&
                        inputData == data?.officeStatusDetailsName)
                    ) {
                      setChanges(false);
                    } else {
                      setChanges(true);
                    }
                  }}
                  register={register}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default OfficeStatusDetailsDetails;
